import React from 'react';
export * from './fieldList';
import { SourceType } from '../../../types';
import { FunctionTypes } from '../../../components/ContributorSection/helpers';
var PREFIX_FOR_TEST_IDS = 'digital-file-form';

/** test ids for form and sections inside it */
export var testIds = {
  DIGITAL_FORM: "".concat(PREFIX_FOR_TEST_IDS, "-test-id"),
  DIGITAL_FILE_PUB_INFO: "".concat(PREFIX_FOR_TEST_IDS, "-pub-info-sec-test-id")
};
export var DIGITAL_FILE_PUB_INFO_SECTION_NAME = 'pubother';
export var DIGITAL_FILE_PUB_INFO_SECTION_TITLE = 'Digital file publication info';

/** function options for contributor - digital file form */
export var DigitalFileContributorFunctionOptions = [FunctionTypes.AUTHOR];
export var digitalFileCitingOptions = {
  DigitalFile: 'Digital file',
  Website: 'An online source'
};
export var citingOptions = [{
  uuid: '',
  value: SourceType.DIGITAL_FILE,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, digitalFileCitingOptions.DigitalFile)
}, {
  uuid: '',
  value: SourceType.WEBSITE,
  child: /*#__PURE__*/React.createElement(React.Fragment, null, digitalFileCitingOptions.Website)
}];